import React  from 'react';
import * as THREE from "three";
import { OrbitControls } from './3jslib/OrbitControls.js';
import { GLTFLoader } from './3jslib/GLTFLoaderObs.js';
import { Easing, Tween, autoPlay } from 'es6-tween';
import { getBgShader } from './3jslib/background';

//import GLTFLoader from 'three-gltf-loader';
import negx from './3jslib/textures/negx.jpg';
import negy from './3jslib/textures/negy.jpg';
import negz from './3jslib/textures/negz.jpg';
import posx from './3jslib/textures/posx.jpg';
import posy from './3jslib/textures/posy.jpg';
import posz from './3jslib/textures/posz.jpg';
//import stairs from './3jslib/models/mainStairs1.glb';
// Select the correct product on the left side of the page and connect it with the red marker. You may zoom in/out, rotate and move it by using your mouse or touch pad.

class CanvasView extends React.Component {

   constructor(props) {
    super(props);

    this.state = {
      toolsPositions: [],
      doorPosition: null,
      shape: null, 
    };

    this.controls = null;
    this.envMap = null;

    this.pointIndex = 0;
    this.imageNameCurrent = 0;
    this.detailInfoCurrent = null;
    this.detailFocused = null;

    this.dragObjects = [];
    this.collisionObjects = [];
    this.pointsForContruction = [];
    this.groupDetails = [];
    this.moveCounter = 0;
    this.detailInfoSel = null;
    this.checkingModule = false;
    this.cameraBehaviorWatching = props.cameraBehavior;

    this.autoIndexes = props.autoIndexes;
    this.putTogether = props.putTogether;
    this.showContruction = props.showContruction;

    this.model = props.model;
    this.isGeneral = props.generalModule;
  
    this.mouse = {vector: new THREE.Vector2()};
    this.raycaster = new THREE.Raycaster();
   
    this.ground = null;
    this.checking = props.step === 2 ? false : props.step === 3 ? true : false;
    // this.checking = true;
    // console.log('constructor', props);
    this.camPosOnCheck = this.props.camPosOnCheck;
    this.inspOpt = this.props.inspOpt;
    this.startPos = this.props.startPos;

   }


  componentWillReceiveProps(nextProps) {
   console.log('componentWillReceiveProps', nextProps, this.props );
    if (nextProps.shape !== this.props.shape) {
    // console.log('nextProps.furnitureSelected', nextProps.furnitureSelected);
    // this.prepareNewFloor(nextProps.shape);
    }

    if (nextProps.elementsNames) {
      this.elementsNames = [...nextProps.elementsNames].map( elem => elem.toLowerCase().replace(new RegExp(" ",'g'),"_") );
    }

    if (nextProps.cameraBehavior) {
      this.cameraBehaviorWatching = nextProps.cameraBehavior;
    }

    if (nextProps.updateDetInfo) {
      this.updateDetInfo = nextProps.updateDetInfo;
    }

    this.checking = nextProps.step === 2 ? false : nextProps.step === 3 ? true : false;
    // this.checking = true;

    this.camPosOnCheck = nextProps.camPosOnCheck;
    this.inspOpt = nextProps.inspOpt;
    this.startPos = nextProps.startPos;

    if (this.checking && this.mainModel && this.inspOpt !== undefined && this.camPosOnCheck ) {

      if (this.inspOpt === null) this.inspOpt = 0;
      else this.inspOpt += 1;

      if (!this.camPosOnCheck[this.inspOpt]) {this.inspOpt = this.camPosOnCheck.length - 1;}

        var camPosOnCheck = this.camPosOnCheck[this.inspOpt].camPos;
        //  console.error('move camera upd!!', camPosOnCheck, this.inspOpt)

        setTimeout( () => {
          if (camPosOnCheck) {
            if (camPosOnCheck.hideMesure) {
              if (this.mesurements) this.mesurements.visible = false;
            } else {
              if (this.mesurements) this.mesurements.visible = true;
            }
          
          var targ = new THREE.Vector3( camPosOnCheck.targ.x, camPosOnCheck.targ.y, camPosOnCheck.targ.z );
          var camPos = new THREE.Vector3( camPosOnCheck.cam.x, camPosOnCheck.cam.y, camPosOnCheck.cam.z ); 
          this.moveCameraToShape( targ, 1, 'InOut', 800, camPos );


          var camPosOnCheckDouble = this.camPosOnCheck[this.inspOpt].camPosNext;
          if (camPosOnCheckDouble) {
            setTimeout( () => {
              var targ = new THREE.Vector3( camPosOnCheckDouble.targ.x, camPosOnCheckDouble.targ.y, camPosOnCheckDouble.targ.z );
              var camPos = new THREE.Vector3( camPosOnCheckDouble.cam.x, camPosOnCheckDouble.cam.y, camPosOnCheckDouble.cam.z ); 
              this.moveCameraToShape( targ, 1, 'InOut', 800, camPos );
            }, 2700);
          }

         }




        }, 700);


      

    }
  
  } 

  componentDidCatch(error, info) {
    console.log('componentDidCatch', error, info)
  }

  componentDidMount() {
    autoPlay(true);
    const that = this;
    //console.log('componentDidMount');
    const scene = new THREE.Scene();
    scene.background = new THREE.Color( 0xffffff );

    this.scene = scene;
    
    const canvasCont = document.getElementById('canvasView');
    let viewportOffset = canvasCont.getBoundingClientRect();
    this.viewportOffset = viewportOffset;
    this.canvasCont = canvasCont;

    const renderWidth  = canvasCont.offsetWidth;
    const renderHeight = canvasCont.offsetHeight;

    this.renderWidth = renderWidth;
    this.renderHeight = renderHeight; 

    const viewSize = 900;
    const aspectRatio = renderWidth / renderHeight;
    this.aspectRatio = aspectRatio;
    this.viewSize = viewSize;

    this.camera = new THREE.PerspectiveCamera( 50, aspectRatio, 0.1, 2000 );

    var geometryPlane = new THREE.PlaneGeometry( 4*aspectRatio, 4, 1 );
    var planeRay = new THREE.Mesh( geometryPlane, new THREE.MeshBasicMaterial( { color: 0xff0000, transparent: true, opacity: 0.0, side: THREE.DoubleSide } ) );
    planeRay.position.set(0,0,-3.5);

    this.camera.add(planeRay); 
    this.planeRay = planeRay;  

    scene.add(this.camera);

    this.camera.position.set( 15, 15, 15 );
    // camera.lookAt( 0, 0, 0 );

    this.renderer = new THREE.WebGLRenderer( { antialias: true } );

    this.renderer.setSize( renderWidth, renderHeight );
    canvasCont.appendChild( this.renderer.domElement );

    this.renderer.shadowMap.enabled = true; 
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    this.controls = new OrbitControls(this.camera, this.renderer.domElement); 
    this.controls.maxDistance = 30;
    
    this.controls.zoomSpeed = 0.35;
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.1;
    this.controls.screenSpacePanning = true;

    window.controls = this.controls;

    //this.controls.screenSpacePanning = false;
      
    this.materialFly   = new THREE.MeshLambertMaterial({ color: 0x0000ff, side: THREE.DoubleSide, transparent: true, opacity: 0.5, depthTest: false }); 
    this.materialFocus = new THREE.MeshLambertMaterial({ color: 0x00ff00, side: THREE.DoubleSide, transparent: true, opacity: 0.5, depthTest: false }); 
    this.materialFocus.name = 'materialFocus';
    this.materialMetal = new THREE.MeshStandardMaterial({color: 0x999999, side: THREE.DoubleSide, roughness: 0.4, metalness: 0.75, envMapIntensity: 1.25});
     
        loadTexture().then((texture) => {
          this.materialMetal.envMap = texture;
          this.materialMetal.needsUpdate = true; 

          /*if (this.mainModel && false) {
            showModel(this.mainModel);
                if (this.checking) {
                  this.groupDetails.forEach((mesh)=>{
                    showModel(mesh);
                  })
                }
            setTimeout( () => {
              showPoints(that.pointIndex);
            }, 500);
          }*/

          if (that.startPos && !that.checking) {
            that.controls.target.set(that.startPos.targ.x, that.startPos.targ.y, that.startPos.targ.z );
            that.camera.position.set(that.startPos.pos.x, that.startPos.pos.y, that.startPos.pos.z );
            that.camera.zoom = that.startPos.zoom;
            that.camera.updateProjectionMatrix();
          }
          loadModel(that.model);
        });

    window.three = THREE;
    window.camera = this.camera;
    window.controls = this.controls;


        var ambient = new THREE.AmbientLight( 0xffffff, 0.5 );
        scene.add( ambient ); 



        //var light2 = new THREE.DirectionalLight( 0xffffff, 0.25 );
        //light2.position.set( -10, 12, 4 );
        //scene.add( light2 );

    /*let [bgShaderVert, bgShaderFrag] = getBgShader();
    var gMat =  new THREE.ShaderMaterial({ 
      uniforms: {}, 
      fragmentShader: bgShaderFrag, 
      vertexShader: bgShaderVert,
      transparent: true,
      //side: THREE.DoubleSide
       blending: THREE.AdditiveBlending
    });*/ 
    // new THREE.MeshLambertMaterial({color: 0xffffff})

    var planeMaterial = new THREE.ShadowMaterial();
    planeMaterial.opacity = 0.2;
  
    var ground = new THREE.Mesh( new THREE.PlaneBufferGeometry( 1,1,1 ),  planeMaterial  );
    ground.scale.multiplyScalar( 20 );
    ground.rotation.x = -Math.PI/2;
    ground.frustumCulled = false;
    ground.receiveShadow = true;
    this.ground = ground;



  new THREE.TextureLoader().load( 'assets/img/bg-min.jpg', function ( texture ) {
   
  texture.magFilter = THREE.LinearFilter;
  texture.minFilter = THREE.LinearFilter;
 
  var shader = THREE.ShaderLib.equirect;
    var materialBg = new THREE.ShaderMaterial({
      fragmentShader: shader.fragmentShader,
      vertexShader: shader.vertexShader,
      uniforms: shader.uniforms,
      depthWrite: false,
      side: THREE.BackSide
    });
    materialBg.uniforms.tEquirect.value = texture;

    var boxBg = new THREE.BoxBufferGeometry(200, 200, 200);
    var bgMesh = new THREE.Mesh(boxBg, materialBg);
    scene.add(bgMesh);

    that.bgMesh = bgMesh;

  }, undefined, function ( err ) {
    console.error( 'An error happened.' );
  }
);




  /*let frag = `
    //uniform sampler2D tEquirect;
    varying vec3 vWorldDirection;
    #include <common>
    void main() {
      vec3 direction = normalize( vWorldDirection );
      vec2 sampleUV;
      
      sampleUV.y = asin( clamp( direction.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
      sampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;
      
      vec3 colobg = vec3(1.0);

      vec4 texColor = texture2D( colobg, sampleUV );
      gl_FragColor = mapTexelToLinear( texColor );

      #include <tonemapping_fragment>
      #include <encodings_fragment>
    }
  `;

  let vert = `
    varying vec3 vWorldDirection;
    #include <common>
    void main() {
      vWorldDirection = transformDirection( position, modelMatrix );
      #include <begin_vertex>
      #include <project_vertex>
    }
  `;*/




    //const loader = new THREE.TextureLoader();
    //let floorTexture = loader.load( gridImage );
    //floorTexture.wrapS = floorTexture.wrapT = THREE.RepeatWrapping;
    //floorTexture.repeat.set( 20, 20 );
    //floorTexture.offset.set( -0.5, 0.5 );


        function createSphereHelpers(points, details) {
          let size = 0.4;
          if (that.cameraBehaviorWatching) size = 0.2; 
          let geom = new THREE.SphereBufferGeometry( size, 24, 24 );
          
          points.forEach((point, index)=>{
            let mat = new THREE.MeshBasicMaterial( { color: 0xff0000, transparent: true, opacity: 0.65 } );
            let sphereHelper = new THREE.Mesh( geom, mat );
            sphereHelper.position.copy(point);
            sphereHelper.userData.id = index+1;
            sphereHelper.userData.name = details[index].userData.name;
            sphereHelper.name = details[index].name;
            //sphereHelper.userData.indexName = details[index].userData.indexName;

            scene.add( sphereHelper );
            sphereHelper.scale.set(0.001,0.001,0.001);

            that.pointsForContruction.push(sphereHelper);
            window.pointsForContruction = that.pointsForContruction;
          })

        }  


       // console.log('Tween', Tween);

      
      function loadModel( url, resolve ) {


          var loader = new GLTFLoader();
          loader.load( url, function ( gltf ) {
          // var singleGeometry = new THREE.Geometry();

          function calcSize( group ) {
            var BoxHelper = new THREE.BoxHelper(group);
            var box3 = new THREE.Box3();
            var size = new THREE.Vector3();
            box3.setFromObject( BoxHelper );
            box3.getSize( size );
            //var pos = box3.getCenter(new THREE.Vector3());
            return size;
          };   


           let object = gltf.scene;
           let points = [];
           
       
           var size = calcSize(object);
           let sizeVal = size.x + size.y + size.z;
          //  console.log('sizeVal', sizeVal);

           if (that.checking) {
              if (sizeVal > 40) {
                sizeVal *= 0.05;
              }
           }

          var light = new THREE.DirectionalLight( 0xffffff, 0.5 );
          light.position.set( 1, 24, -8 );
          light.castShadow = true;

          light.shadow.mapSize.width = 1024*2; 
          light.shadow.mapSize.height = 1024*2;
          light.shadow.camera.near = 0.1; 
          light.shadow.camera.far = sizeVal > 5 ? sizeVal*42.3 : 400;

          var side = sizeVal*2.3;
          light.shadow.camera.top = side;
          light.shadow.camera.bottom = -side;
          light.shadow.camera.left = side;
          light.shadow.camera.right = -side;

          scene.add( light );



          let isCarriage = false;   
          for (var i = object.children.length - 1; i >= 0; i--) {
              if (object.children[i].name === 'carriage') {
                isCarriage = true; 
                that.mainModel = object.children[i];
              }
          }

          that.modelGroup = object;

          if (isCarriage) {

            // console.log('object', object);
            that.checkingModule = true;

              object.traverse( function(node) {
                  if (node.isMesh && node.name !== 'carriage') {
                    node.material = that.materialMetal;
                  }
              });

              that.mainModel.material.metalness = 0.85;
              that.mainModel.material.roughness = 0.3;
              that.mainModel.material.envMap = that.envMap;
              that.mainModel.material.needsUpdate = true; 

              window.mainmat = that.mainModel.material;

              let size = calcSize(object);
              
              that.ground.position.y = ((-size.y/2)*12);

              that.ground.scale.set(0.005,0.005,0.005);
              object.scale.set(0.005,0.005,0.005);

              that.scene.add(object);
              that.scene.add(that.ground);

              showModel(object, 12.5);
              showModel(that.ground, 15*1.5);

          } else {

              for (var i = object.children.length - 1; i >= 0; i--) {
                let node = object.children[i];

                if (node.isMesh) {

                //  console.log('nodeisMesh', node, that.checking);
                  node.material = that.materialMetal.clone();
                  node.material.emissive.setHex(0x444444);
                  // node.material.emissiveIntencity = 0.1;
                  node.castShadow = true;

                  if (!that.checking) node.scale.set(0.005,0.005,0.005);

                  if (node.rotation.x && !that.checking) {
                    node.userData.rotX = node.rotation.x;
                    node.rotation.x    = 0;
                  }
                  // console.error( 'node mesh', node );
                  if (node.children.length) {
                    node.children.forEach( (group) => {
                      that[group.name] = group;
                      if (group.name === 'sourcePos') {
                        that[group.name] = new THREE.Vector3(-22.7236, 1.8695789, -113.03759);
                        // group.position.clone().add(group.parent.position);
                      }

                      if (group.name === 'Rulers') {
                        that.mesurements = group;
                      }

                      if (!that.checking) group.visible = false;
                    });
                  }


                  that.mainModel = node;
                  
                } else if (node.isObject3D && node.name === 'Details') {
            
                  if (!that.checking) node.scale.set(5,5,5);
                  node.children.forEach((mesh, index) => {
                      
                      const re = mesh.userData.name.split('.');
                      mesh.name = re[0].toLowerCase().replace(new RegExp(" ",'g'),"_");
                      
                      //if (mesh.name === "Cleat Ladder TBA-I".toLowerCase().replace(new RegExp(" ",'g'),"_") ) console.error('mesh', mesh, mesh.name);
                      //if (re[1]) mesh.userData.indexName = re[1];
                    //  console.log('mesh.name', mesh.userData.name );
                      mesh.material    = that.materialMetal;
                      mesh.castShadow = true;

                      if (that.cameraBehaviorWatching) {
                        let size = calcSize(mesh);
                        let sizeVolume = size.x+size.y+size.z;
                        mesh.userData.sizeVolume = sizeVolume;
                        //console.log('sizeVolume', mesh.userData.sizeVolume, mesh.name );
                      }
                      
                      if (!that.checking) mesh.visible = false;
                      if (!that.isGeneral && !that.checking) points.push( mesh.position.clone().multiplyScalar(5) );
                  });
                  // console.error( 'node group', node );
                  //console.log('node.children', node.children.length, node.rotation.x );
                  if (node.rotation.x && !that.checking) {
                    node.userData.rotX = node.rotation.x;
                    node.rotation.x = 0;
                  }

                  that.groupDetails = node.children;
                }

              }


              /*
    if (that.mainModel.userData.rotX) { 

          function calcSize( group ) {
            var BoxHelper = new THREE.BoxHelper(group);
            var box3 = new THREE.Box3();
            var size = new THREE.Vector3();
            box3.setFromObject( BoxHelper );
            box3.getSize( size );
            //var pos = box3.getCenter(new THREE.Vector3());
            return size;
          };  

          let size = calcSize(that.mainModel);
          that.ground.position.y = ((-size.z/2))*0.5;

                      var coords = {x: that.modelGroup.rotation.x };
                      new Tween(coords)
                      .to({ x: that.mainModel.userData.rotX || Math.PI/2  }, time || 1500)
                      .easing( Easing.Exponential.InOut )
                      .on('update', ({ x }) => {
                        that.modelGroup.rotation.x = x;
                      })
                      .start();
    }

// third module
{
  cam:  {x: 2.8982894293079084, y: 9.638869183765745, z: 1.0705485221158142 },
  targ: {x: 2.902563063653894, y: 9.789446516715795, z: -4.9965671521215995 }
},
{
  cam:  {x: 2.5294123987992765, y: 8.970431792023682, z: 2.4362615197345487 },
  targ: {x: 2.5346593006443947, y: 9.155301254903854, z: -5.012564900243709}
},
{
  cam:  {x: 3.19813699273835, y: 10.130436943965991, z: 0.11926827735770473},
  targ: {x: 4.947722632288743, y: 9.939765356520754, z: -4.50004806436475}
},
{
  cam:  {x: 2.486598922301689, y: 7.415132257401122, z: 6.318833084354907},
  targ: {x: 3.4898232226216055, y: 7.622608448998693, z: -4.865719825161971}
},
{
  cam:  {x: 2.47713112257793, y: 7.264987394653251, z: 0.48245646741589177},
  targ: {x: 4.188508184503921, y: 5.003347767653864, z: -2.3753709276635413}
},
{
   cam: {x: 4.311640384637841, y: -9.242026931832, z: 2.378840720516531},
  targ: {x: 4.7219703598789176, y: -9.150711127302296, z: -2.546479549734576}
},
{
  cam:  {x: 4.82402942091263, y: -8.990080826927443, z: 0.30261668618015697},
  targ: {x: 3.0279920748218414, y: -9.115542814121039, z: -0.4809146872972998}
}


 },
 }

 },
 }

              */

              object.name = 'modelGroup';
              object.castShadow = true;
              
              // console.log('that.modelGroup', that.modelGroup, that.cameraBehaviorWatching);

              that.scene.add(object);


              if (that.checking) {
                
                object.scale.set(0.005,0.005,0.005);

                // function calcSize( group ) {
                //   var BoxHelper = new THREE.BoxHelper(group);
                //   var box3 = new THREE.Box3();
                //   var size = new THREE.Vector3();
                //   box3.setFromObject( BoxHelper );
                //   box3.getSize( size );
                //   //var pos = box3.getCenter(new THREE.Vector3());
                //   return size;
                // };  
      
                // let sizeobj = calcSize(object);

                let sizeobj = calcSize(that.mainModel);
                let sval = sizeobj.x + sizeobj.y + sizeobj.z;

                if (sval > 9) {
                  object.userData.maxScale = (15 / sval)*2;
                }
                if (sval > 40) {
                  object.userData.maxScale = (17 / sval)*2;
                }

                //  console.log('sizeobj', sval, that.controls.maxDistance );
                // that.moveCamAndcont( 20/sval );

                // var coords = that.modelGroup.scale;
                // new Tween(coords)
                // .to({ x: that.modelGroup.scale.x/2, y: that.modelGroup.scale.y/2, z:that.modelGroup.scale.z/2}, 600)
                // .easing( Easing.Exponential.In )
                // .on('update', ({ x,y,z }) => {
                //   that.modelGroup.scale.set(x,y,z);
                // })
                // .start(); 

              }  

              that.groupDetailsRef = object;
              let size = calcSize(that.mainModel);
              //let siz2 = calcSize(that.mainModel);
              console.log('object size', size, object);
              let sizeValCheck = size.x + size.y + size.z;

              if (that.cameraBehaviorWatching)  {
                that.controls.panSpeed = 0.1;
                that.controls.rotateSpeed = 0.45; 
                that.controls.maxDistance = 60;
                              
                if (sizeValCheck > 0.2 && !that.checking) {
                  that.controls.panSpeed = 0.15;
                  that.controls.maxDistance = 120;
                }
                if (sizeValCheck > 0.2 && that.checking) {
                  that.controls.panSpeed = 0.3;
                  that.controls.maxDistance = 70;
                }
              }
              
              that.ground.scale.set(0.005,0.005,0.005);
              that.scene.add(that.ground);

              if (size.y >= 0.5) {
                that.ground.position.y = (-size.y/2);
              } else {
                that.ground.position.y = ((-size.y/2)*1000)-1;
              }

              if (that.checking) {
                  let scale = object.userData.maxScale || 5;
                  that.ground.position.y = ( (-size.y/2) * scale)-1;
              }
              
              //object.scale.set(5,5,5);
              //that.scene.add(object);

             // console.log('that.scene', that.scene, points);
             if (points.length) createSphereHelpers(points, that.groupDetails);

            console.log('that.modelGroup', that.modelGroup);
            

            if (that.startPos && !that.checking) {
              that.controls.target.set(that.startPos.targ.x, that.startPos.targ.y, that.startPos.targ.z );
              that.camera.position.set(that.startPos.pos.x, that.startPos.pos.y, that.startPos.pos.z );
              that.camera.zoom = that.startPos.zoom;
              that.camera.updateProjectionMatrix();
            }
    
            console.log(that.camera.position)
              // if ( that.envMap ) {}
               
                if (that.checking) {
                  
                  showModel(that.groupDetailsRef, that.groupDetailsRef.userData.maxScale);
                  showModel(that.ground, 15*20.5);
                  setTimeout( () => {
                    if (points.length) showPoints(that.pointIndex);
                  }, 500);


                    if (that.inspOpt !== undefined) {

                      var time = 1500;
                      if (sizeValCheck > 0.2)  time = 2500;

                      if (that.inspOpt === null) that.inspOpt = 0;
                      else that.inspOpt += 1;
                      // console.error('move camera loaded!!',  that.camPosOnCheck, that.inspOpt)

                      if ( that.camPosOnCheck[that.inspOpt] ) {
                        var camPosOnCheck = that.camPosOnCheck[that.inspOpt].camPos;

                        if (camPosOnCheck)
                        setTimeout( () => {
                          var targ = new THREE.Vector3( camPosOnCheck.targ.x, camPosOnCheck.targ.y, camPosOnCheck.targ.z );
                          var camPos = new THREE.Vector3( camPosOnCheck.cam.x, camPosOnCheck.cam.y, camPosOnCheck.cam.z ); 
                          that.moveCameraToShape( targ, 1, 'InOut', time, camPos );

                          var camPosOnCheckDouble = that.camPosOnCheck[that.inspOpt].camPosNext;
                          if (camPosOnCheckDouble) {
                            setTimeout( () => {
                              var targ = new THREE.Vector3( camPosOnCheckDouble.targ.x, camPosOnCheckDouble.targ.y, camPosOnCheckDouble.targ.z );
                              var camPos = new THREE.Vector3( camPosOnCheckDouble.cam.x, camPosOnCheckDouble.cam.y, camPosOnCheckDouble.cam.z ); 
                              that.moveCameraToShape( targ, 1, 'InOut', time, camPos );
                            }, 2700);
                          }

                        }, time);



                      }

                    }


                } else {
                  showModel(that.mainModel, null, 1000);
                  showModel(that.ground, 15*20.5);
                  
                  var time = 1300;
                  if (sizeValCheck > 0.2)  time = 2500;
                  setTimeout( () => {
                    if (points.length) showPoints(that.pointIndex, false, true);
                  }, time);
                }

              
            
          }


              //return model;
            }, undefined, function ( error ) {
                console.error( error );
           });
      };

      function showModel(mesh, scale, time) {
                var coords = {x: mesh.scale.x, y: mesh.scale.y, z: mesh.scale.z};

                new Tween(coords)
                .to({ x: scale || 5, y: scale || 5, z: scale || 5 }, time || 500)
                .easing( Easing.Cubic.In )
                .on('update', ({ x, y, z }) => {
                  mesh.scale.set(x,y,z);
                })
                .start(); 
      }

       function showPoints(index, isAuto, isFirstMove, camPos) {
        let delay = isFirstMove ? 1000 : 0;
          //  console.log('showPoints', index, that.elementsNames, index );

          let isReady = false;

          if (that.elementsNames[index]) {

                that.pointsForContruction.forEach( sphereHelper => {
                  // console.log('sph',  that.elementsNames[index], sphereHelper.name );
                  //console.log('startAuto', that.autoIndexes, index, that.autoIndexes.some( range =>  range.start === index ) );
                  if (that.elementsNames[index] === sphereHelper.name && !sphereHelper.userData.done && !isReady) {
                    // console.log('equal', sphereHelper.userData.name, that.elementsNames[index], sphereHelper.userData.done, isReady );
                    if (that.cameraBehaviorWatching && !isAuto) {
                      setTimeout( () => {
                        moveCameraToShape( sphereHelper.position.clone(), 8, isAuto ? 'InOut' : 'In', isFirstMove ? 1800 : isAuto ? 800 : null, isFirstMove ? that.sourcePos : camPos );
                      }, isAuto ? 0 : 300 );
                    }
          
                    setTimeout( () => {
                      var coords = {x: sphereHelper.scale.x, y: sphereHelper.scale.y, z: sphereHelper.scale.z};
                      new Tween(coords)
                      .to({ x: 1, y: 1, z: 1 }, 500)
                      .easing( Easing.Cubic.In )
                      .on('update', ({ x, y, z }) => {
                        sphereHelper.scale.set(x,y,z);
                      })
                      .start(); 

                      // if (sphereHelper.name === 'Sleeve Joint no 70'.toLowerCase().replace(new RegExp(" ",'g'),"_")) {
                      //   that.updateDetInfo('adviceConstruct');
                      // }
                    }, delay);

                    //setTimeout( () => {
                    //  that.rotateModel();
                    //}, 2000);


                    sphereHelper.userData.done = true;
                    window.sphereHelper = sphereHelper;
                    that.currentSphere = sphereHelper;

                    //that.groupDetails[sphereHelper.userData.id-1].userData.id = sphereHelper.userData.id;

                    delay += 50;
                    that.pointIndex++;
                    that.imageNameCurrent = that.elementsNames[index];
                    isReady = true;

                  }

                });

          } else {
            // if (that.elementsNames[index] === 'startAuto') {
            //   console.log('startAuto' );
            //   const re = mesh.userData.name.split('.');
            // } else if (that.elementsNames[index] === 'endAuto') {
            //   console.log('endAuto' );
            // } else {}
            //console.log('isComplete!!' );
            that.isComplete = true;
            that.rotateModel(); 
          }

       }

    //this.leftMenu = document.getElementById("sidebarLeft").children[0].offsetWidth;
    //this.raycaster.linePrecision = 0.05;
    this.renderer.domElement.addEventListener( 'mousemove', onDocumentMouseMove, false );
    this.renderer.domElement.addEventListener( 'mousedown', onDocumentMouseDown, false );  
    this.renderer.domElement.addEventListener( 'mouseleave', onDocumentMouseLeave, false);
    this.renderer.domElement.addEventListener( 'mouseup', onDocumentMouseUp, false );  
    this.renderer.domElement.addEventListener( 'wheel', onMouseWheel, false ); 

    window.onDocumentMouseUp = onDocumentMouseUp;


    window.addEventListener( 'resize', onWindowResize, false );
    window.addEventListener('scroll', function() {
      that.viewportOffset = canvasCont.getBoundingClientRect();
    });


    function onMouseWheel(event) {

      if (that.checking) that.controls.zoomSpeed = 0.35;   
      else that.controls.zoomSpeed = 0.35;        

      if (that.cameraBehaviorWatching ) return;
      if (that.checkingModule) return;
      if (!that.controls.enabled) return;

      that.controls.zoomSpeed = 2; 
      
      event.preventDefault();
      event.stopPropagation();
      //console.log('dfg', event);
       

      var mX = that.mouse.vector.x;
      var mY = that.mouse.vector.y;

      var vector = new THREE.Vector3(mX, mY, 0.1);
      var vectorBACK = new THREE.Vector3(0, 0, 0.1);

      let getShortDist = () => {
        return (Math.abs(that.camera.position.x) + Math.abs(that.camera.position.y) + Math.abs(that.camera.position.z))/3;
      }

      //console.log('dfg', mX, mY);
      let short = getShortDist();

      var factor = 0.25*short;

      var koefUp = 1, koefBack = 1;
      if (that.checking) {
        koefBack = 0.4;
        koefUp *= 0.1;
      }
     

      that.moveCounter += 1;
      //console.log('short', short, that.moveCounter);
      if (event.deltaY < 0 && !that.isComplete &&  !that.mouse.selectedContrls) {
        that.controls.zoomSpeed = 0.35;

         vector.unproject(that.camera);
         vector.sub(that.camera.position);
        // console.log('up', short);
         that.camera.position.addVectors(that.camera.position, vector.setLength(factor*koefUp));
         that.controls.target.addVectors(that.controls.target, vector.setLength(factor));
         that.moveCounter = 0;

      } else if (event.deltaY >= 0 && getShortDist() >= 16 || event.deltaY >= 0 && that.moveCounter >= 8) {
       // console.log('more', short);
        //that.controls.target = new THREE.Vector3(0, 0, 0); 
        if (!that.checking) {
          moveCameraToShape({ x: 0, y: 0, z: 0 }, 1, 'In', 300); 
          that.mouse.selectedContrls = false;
          that.moveCounter = 0;
        }

      } else if (event.deltaY >= 0 && getShortDist() < 16 &&  !that.mouse.selectedContrls) {
        that.controls.zoomSpeed = 0.35;

         vectorBACK.unproject(that.camera);
         vectorBACK.sub(that.camera.position);
         that.camera.position.subVectors(that.camera.position, vectorBACK.setLength(factor*2*koefBack));
         that.controls.target.subVectors(that.controls.target, vectorBACK.setLength(factor*2));
         //that.moveCounter = 0;
        // console.log('less', short);
      }

    };
      
    function loadTexture() {
          return new Promise(resolve => {
            getEnvMap(resolve);
          });
    }

    function getEnvMap(resolve) {
        if ( that.envMap ) {
          return that.envMap;
        }
        var path = 'assets/textures/';
        var format = '.jpg';
        var urls = [ posx, negx, posy, negy, posz, negz ];
        that.envMap = new THREE.CubeTextureLoader().load( urls, resolve );
        that.envMap.format = THREE.RGBFormat;
        //resolve(that.envMap);
    }

    /*function getCanvasElemPosition(x, z, camera, clientWidth, clientHeight) {
          let vector = new THREE.Vector3(x, 0, z);
          vector.project( camera );
          vector.x = ( vector.x + 1) * clientWidth / 2;
          vector.z = 0;
          vector.y = - ( vector.y - 1) * clientHeight / 2;
          return {x: Math.round(vector.x * 10) / 10, y: Math.round(vector.y * 10) / 10};
    };*/
    function onDocumentMouseLeave ( event ) {
       if (that.meshToFly && !that.meshToFly.userData.placed) that.meshToFly.visible = false; 
    }

    function onDocumentMouseMove ( event ) {
      
      let top = that.viewportOffset.top;
      let left = that.viewportOffset.left;

      that.mouse.vector.x = ( (event.clientX-left) / that.renderWidth) * 2 - 1;
      that.mouse.vector.y = - ((event.clientY-top) / that.renderHeight) * 2 + 1;

      //if (that.mouse.selected) {
      //  that.mouse.selected.material.color.setHex(0xff0000);
      //}
      if (that.groupDetails && that.elementName && !that.mouse.down && that.meshToFly) {
        that.meshToFly.visible = true;
      } else if (that.meshToFly && !that.meshToFly.userData.placed) that.meshToFly.visible = false;
      //if (that.meshToFly && that.element && !that.mouse.down) that.meshToFly.visible = true;
    }

    function onDocumentMouseDown ( event ) {
       if (event.which !== 3) {
        that.mouse.down = true;
        that.mouse.up = false;
        if (that.meshToFly && !that.meshToFly.userData.placed) that.meshToFly.visible = false;

          if (!that.mouse.selected && that.detailInfoCurrent) {
            that.mouse.selected = that.detailInfoCurrent;
            //that.detailInfoSel = that.detailInfoCurrent.userData.imagesTitelsIndex;
            //that.updateDetInfo();
          }
       }
    }

    function autoProceed(event) {
  
            // console.error('autoProceed!', that.elementName);

            let model = that.meshToFly;
            model.scale.set( 1, 1, 1 );
            let sph = that.currentSphere;

            model.material = that.materialMetal;
            model.userData.placed = true;
            model.visible = true;  
            sph.visible = false;

            model.position.copy( sph.position.clone().multiplyScalar(1/5) );
            that.currentSphere =  null;
            that.controls.enabled = false;

            // if (!that.cameraBehaviorWatching) {
              // moveCameraToShape( model.position.clone().multiplyScalar(5), 4, 'Out' );
            // } else {
              //moveCameraPosToOrigin();
             // that.camera.zoom = 8;
              //console.error('that.camera.zoom', that.camera.zoom);
               moveCameraToShape( model.position.clone().multiplyScalar(5), 2 / ( model.userData.sizeVolume < 0.58 ? model.userData.sizeVolume : 0.25 ), 'InOut', 800 );
            // }
            

              setTimeout( () => {

                if ( that.putTogether && that.putTogether.some(range => range.start === that.pointIndex-1)) {
                    //console.error('putTogether', that.pointIndex-1, that.groupDetails, that.elementsNames[1] );

                    let range = that.putTogether.find( range => range.start === that.pointIndex-1);

                    for (var i = range.start+1; i <= range.end; i++) {
                        let det = that.groupDetails.find( mesh => (mesh.name === that.elementsNames[i] && !mesh.userData.placed) );
                        det.userData.placed = true;
                        det.visible = true; 
                        det.material = that.materialMetal;

                        let sphereHelper = that.pointsForContruction.find( mesh => (mesh.name === that.elementsNames[i] && !mesh.userData.done) );
                        sphereHelper.userData.done = true;

                        det.userData.placedPos = sphereHelper.position.clone().multiplyScalar(1/5);
                        // console.log('sphereHelper showPoints', sphereHelper.userData, i)
                        
                        that.pointIndex++;
                        that.imageNameCurrent = that.elementsNames[i];

                        if (that.dragElemUpdate) {
                          that.dragElemUpdate( i+1, true );
                        }
                    }

                    showPoints(range.end+1);
                    that.controls.enabled = true;
                    that.element = range.end+1;
                  
                    if (that.dragElemUpdate) {
                      that.dragElemUpdate( range.end + 2, false );
                    }

                } else if (that.showContruction && that.showContruction.some(range => range.index === that.pointIndex-1)) {
                  // const capitalize = name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
                  console.error('setTimeout showPoints showContruction!!', that.pointIndex, that.pointsForContruction);

                } else {
                  proceed();
                }

              }, 1200);

            

            function proceed() {
   
              showPoints(that.pointIndex, true);
              that.controls.enabled = true;
      
                // console.error('autoIndexes true!!');
                if (!that.autoIndexes.some(range => range.end === that.pointIndex-1)) {
                    // console.error('pointIndex true!!');
                    // setTimeout( () => {
                      that.elementName = that.elementsNames[that.pointIndex-1].toLowerCase().replace( new RegExp(" ",'g'),"_" );
                      that.meshToFly   = that.groupDetails.find( mesh => (mesh.name === that.elementName && !mesh.userData.placed) );
                      that.element = that.pointIndex;
                      autoProceed(true);
                    // }, 0);
                } else {
                  setTimeout( () => {
                    moveCameraToShape( that.currentSphere.position.clone(), 8, 'In',  null );
                  }, 300 );
                  console.error('that.dragElemUpdate', that.dragElemUpdate, that.element );
                  if (that.dragElemUpdate) that.dragElemUpdate( that.element, false );  
                }
               
            };

            that.meshToFly = null;
            if (that.dragElemUpdate) that.dragElemUpdate( that.element, event === true ? true : false );

      
    };

    function onDocumentMouseUp( event ) {

      that.mouse.down = false;
      that.mouse.up = true;

      that.mouse.selected = null;

      // console.log('this.onDocumentMouseUp', event, that.elementName );

      if (that.elementName) {
        if (that.mouse.hovered) {

          // console.log('this.elementName2', that.elementName );
          
          if (that.mouse.hovered.name === that.elementName ) {

            // console.log('canvasRef up THE SAME!!', that.elementName);

            let model = that.meshToFly;
            model.scale.set( 1, 1, 1 );
            let sph = that.currentSphere;

            model.material = that.materialMetal;
            model.userData.placed = true;
            model.visible = true;  
            sph.visible = false;

            model.position.copy( sph.position.clone().multiplyScalar(1/5) );
            that.currentSphere =  null;
            that.controls.enabled = false;

            if (!that.cameraBehaviorWatching) {
              moveCameraToShape( model.position.clone().multiplyScalar(5), 4, 'Out' );
            } else {
              //moveCameraPosToOrigin();
             // that.camera.zoom = 8;
              //console.error('that.camera.zoom', that.camera.zoom);
              moveCameraToShape( model.position.clone().multiplyScalar(5), 4 / ( model.userData.sizeVolume < 0.58 ? model.userData.sizeVolume : 0.25 ), 'Out' );
            }
            

            setTimeout( () => {

              if (!that.cameraBehaviorWatching) {
                moveCameraToShape({ x: 0, y: 0, z: 0 }, 1, 'In'); 
                moveCameraPosToOrigin();
              }

              setTimeout( () => {

                if ( that.putTogether && that.putTogether.some(range => range.start === that.pointIndex-1)) {
                    //console.error('putTogether', that.pointIndex-1, that.groupDetails, that.elementsNames[1] );

                    let range = that.putTogether.find( range => range.start === that.pointIndex-1);

                    for (var i = range.start+1; i <= range.end; i++) {
                        let det = that.groupDetails.find( mesh => (mesh.name === that.elementsNames[i] && !mesh.userData.placed) );
                        det.userData.placed = true;
                        det.visible = true; 
                        det.material = that.materialMetal;

                        let sphereHelper = that.pointsForContruction.find( mesh => (mesh.name === that.elementsNames[i] && !mesh.userData.done) );
                        sphereHelper.userData.done = true;

                        det.userData.placedPos = sphereHelper.position.clone().multiplyScalar(1/5);

                        // console.log('sphereHelper showPoints', sphereHelper.userData, i)
                        
                        that.pointIndex++;
                        that.imageNameCurrent = that.elementsNames[i];

                        if (that.dragElemUpdate) {
                          that.dragElemUpdate( i+1, true );
                        }
                    }

                    showPoints(range.end+1);
                    that.controls.enabled = true;
                    that.element = range.end+1;
                  
                    if (that.dragElemUpdate) {
                      that.dragElemUpdate( range.end + 2, false );
                    }

                } else if (that.showContruction && that.showContruction.some(range => range.index === that.pointIndex-1)) {
                  // const capitalize = name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
                  // console.log('setTimeout showPoints showContruction', that.pointIndex, that.pointsForContruction);
                  let constr = that.showContruction.find( range => range.index === that.pointIndex-1);
                  // let targPoint = that.pointsForContruction.find( mesh => mesh.userData.name.toLowerCase() === constr.targPoint.toLowerCase() );
                  let targPoint = new THREE.Vector3(constr.targPoint.x, constr.targPoint.y, constr.targPoint.z);
                  let pos = new THREE.Vector3(constr.pos.x, constr.pos.y, constr.pos.z);
                  // if (targPoint) {}
                  // console.error('targPoint pos',targPoint, pos );
                    showContructionView(pos, targPoint, constr.zoom || 3.2, 'InOut', 2000);
                  
                  setTimeout( () => {
                    showPoints(that.pointIndex, null, null, constr.nextCamPos );
                    that.controls.enabled = true;
                  }, 4000);
                  
                } else {
                  // console.log('setTimeout showPoints', that.pointIndex)
                  // showPoints(that.pointIndex);
                  // that.controls.enabled = true;
                  let isAutoProceed = false;
                  if (that.autoIndexes && that.autoIndexes.some(range => range.start === that.pointIndex-1)) isAutoProceed = true;
                  // console.log('proceed auto!!', that.autoIndexes, isAutoProceed );

                  // console.log('showPoints after!!', autoProceed );
                  if ( isAutoProceed ) {
                    // console.log('autoIndexes true!!');
                    // if (!that.autoIndexes.some(range => range.end === that.pointIndex-1)) {
                        // console.log('pointIndex true!!');
                        showPoints(that.pointIndex);
                        that.controls.enabled = true;

                        setTimeout( () => {

                          that.elementName = that.elementsNames[that.pointIndex-1].toLowerCase().replace( new RegExp(" ",'g'),"_" );
                          that.meshToFly   = that.groupDetails.find( mesh => (mesh.name === that.elementName && !mesh.userData.placed) );
                          that.element = that.pointIndex;
                          // onDocumentMouseUp(true);
                          autoProceed(true);
                        }, 500 );
                      // } else {
                      //   if (that.dragElemUpdate) that.dragElemUpdate( that.element-1, false );  
                      // }
                  } else {
                    showPoints(that.pointIndex);
                    that.controls.enabled = true;
                  }

                }

              }, 600);
            // var el = document.getElementById('imagesToDrag_List');
            // el.children[that.pointIndex-1].style.height = 0;
            }, 1200);

            that.meshToFly = null;
            if (that.dragElemUpdate) that.dragElemUpdate( that.element, event === true ? true : false );
          } else {
            console.log('not THE SAME!!', that.elementName, that.mouse.hovered.name);
            if (that.meshToFly && !that.meshToFly.userData.placed) that.meshToFly.visible = false; 
            if (that.dragElemUpdate) that.dragElemUpdate('wrong');
          }
        
        } else {
           if (that.dragElemUpdate) that.dragElemUpdate(null);
        }
      }

      that.elementName = null;
      //that.element = null;
    };

    function moveCameraToShape(newPos, zoom, type, time, sourcePos) {
      that.moveCameraToShape(newPos, zoom, type, time, sourcePos);
                // var coords  = {
                //   x: that.controls.target.x, y: that.controls.target.y, 
                //   z: that.controls.target.z, w: that.camera.zoom
                // };

                // var tweenData = { x: newPos.x, y: newPos.y, z: newPos.z, w: zoom};

                // if (sourcePos) {
                //   coords.a = that.camera.position.x;
                //   coords.b = that.camera.position.y;
                //   coords.c = that.camera.position.z;

                //   tweenData = { x: newPos.x, y: newPos.y, z: newPos.z, w: zoom, 
                //                 a: sourcePos.x, b: sourcePos.y, c: sourcePos.z };
                // }

                // new Tween(coords)
                // .to(tweenData, time || 1000)
                // .easing( Easing.Quartic[type] )
                // .on('update', ({ x, y, z, w, a,b,c }) => { 
                //     that.controls.target.set(x, y, z );
                //     that.camera.zoom = w;
                //     if (sourcePos) that.camera.position.set(a,b,c);
                //     that.camera.updateProjectionMatrix();
                // })
                // .start(); 

    };

    function showContructionView(newPos, targ, zoom, type, time) {

      var coords  = {
        x: that.controls.target.x, y: that.controls.target.y, 
        z: that.controls.target.z, w: that.camera.zoom,
        a: that.camera.position.x, b: that.camera.position.y, c: that.camera.position.z
      };

      new Tween(coords)
      .to({ x: targ.x, y: targ.y, z: targ.z, w: zoom, 
        a: newPos.x, b: newPos.y, c:newPos.z }, time || 1000)
      .easing( Easing.Quartic[type] )
      .on('update', ({ x, y, z, w, a, b, c }) => { 
          that.controls.target.set(x, y, z );
          that.camera.position.set(a, b, c );
          that.camera.zoom = w;

          that.camera.updateProjectionMatrix();
      })
      .start(); 

    };



    function moveCameraPosToOrigin(time) {

                var coords  = { x: that.camera.position.x, y: that.camera.position.y, z: that.camera.position.z };

                new Tween(coords)
                .to({ x: 15, y: 15, z: 15 }, time || 1000)
                .easing( Easing.Quartic.In )
                .on('update', ({ x, y, z, w }) => { 
                    that.camera.position.set(x, y, z);
                    that.camera.updateProjectionMatrix();
                })
                .start(); 

    };

    function onWindowResize() {
      //that.leftMenu = document.getElementById("sidebarLeft").children[0].offsetWidth;
      that.renderWidth = that.canvasCont.offsetWidth;
      that.renderHeight = that.canvasCont.offsetHeight;
      
      that.aspectRatio = that.renderWidth / that.renderHeight;
      that.viewportOffset = that.canvasCont.getBoundingClientRect();
      //console.log(that.renderWidth, that.renderHeight);
      that.renderer.setSize( that.renderWidth, that.renderHeight );

      /*if (that.camera.type==="OrthographicCamera") {
        that.camera.left = -that.aspectRatio*that.viewSize / 2;
        that.camera.right = that.aspectRatio*that.viewSize / 2;
        that.camera.top = that.viewSize / 2;
        that.camera.bottom = -that.viewSize / 2;
        that.camera.updateProjectionMatrix();
      } else {*/
        that.camera.aspect = that.aspectRatio;
        that.camera.updateProjectionMatrix();
      //}

    }



    onWindowResize();  
    this.start();

    //debug
    window.scene = this.scene;
    window.THREE = THREE;
  }  

 moveCamAndcont(scale) {
  const that = this;
  if (!scale) scale = 1;

                var coords  = {
                  x: that.controls.target.x, y: that.controls.target.y, 
                  z: that.controls.target.z, w: that.camera.zoom, 
                  a: that.camera.position.x, b: that.camera.position.y, c: that.camera.position.z
                };

                new Tween(coords)
                .to({ x: 0, y: 0, z: 0, w: 1, a: 15*scale, b: 15*scale, c: 15*scale  }, 1000)
                .easing( Easing.Quartic.Out )
                .on('update', ({ x, y, z, w, a, b, c }) => { 
                    that.controls.target.set(x, y, z );
                    that.camera.zoom = w;
                    that.camera.position.set(a, b, c );
                    that.camera.updateProjectionMatrix();
                })
                .start();
 }

  moveCameraToShape(newPos, zoom, type, time, sourcePos) {
   const that = this;

                var coords  = {
                  x: that.controls.target.x, y: that.controls.target.y, 
                  z: that.controls.target.z, w: that.camera.zoom
                };

                var tweenData = { x: newPos.x, y: newPos.y, z: newPos.z, w: zoom};

                if (sourcePos) {
                  coords.a = that.camera.position.x;
                  coords.b = that.camera.position.y;
                  coords.c = that.camera.position.z;

                  tweenData = { x: newPos.x, y: newPos.y, z: newPos.z, w: zoom, 
                                a: sourcePos.x, b: sourcePos.y, c: sourcePos.z };
                }

                this.controls.enabled = false;

                new Tween(coords)
                .to(tweenData, time || 1000)
                .easing( Easing.Quartic[type] )
                .on('update', ({ x, y, z, w, a,b,c }) => { 
                    that.controls.target.set(x, y, z );
                    that.camera.zoom = w;
                    if (sourcePos) that.camera.position.set(a,b,c);
                    that.camera.updateProjectionMatrix();
                })
                .start(); 

                setTimeout( () => {
                  this.controls.enabled = true;
                }, time || 1100);

  };

  rotateModel(time) {
    const that = this;

    if (that.modelGroup.userData.maxScale) return;

    function calcSize( group ) {
      var BoxHelper = new THREE.BoxHelper(group);
      var box3 = new THREE.Box3();
      var size = new THREE.Vector3();
      box3.setFromObject( BoxHelper );
      box3.getSize( size );
      //var pos = box3.getCenter(new THREE.Vector3());
      return size;
    }; 

    let sizeobj = calcSize(that.mainModel);
    let sval = sizeobj.x + sizeobj.y + sizeobj.z;

    if (sval > 250) {
      that.modelGroup.userData.maxScale = 3;
    }
    var maxScale = that.modelGroup.userData.maxScale;

    if (that.mainModel.userData.rotX) { 
 
          let size = calcSize(that.mainModel);
          that.ground.position.y = ((-size.z/2))*0.5;

          var coords = {x: that.modelGroup.rotation.x };
          new Tween(coords)
          .to({ x: that.mainModel.userData.rotX || Math.PI/2  }, time || 1500)
          .easing( Easing.Exponential.InOut )
          .on('update', ({ x }) => {
            that.modelGroup.rotation.x = x;
          }).start();
    }

    if (this.cameraBehaviorWatching) {

        var scale =  maxScale || 2;
        this.moveCamAndcont(maxScale);


                      var coords = that.modelGroup.scale;
                      new Tween(coords)
                      .to({ x: that.modelGroup.scale.x/scale, y: that.modelGroup.scale.y/scale, z:that.modelGroup.scale.z/scale}, time || 600)
                      .easing( Easing.Exponential.In )
                      .on('update', ({ x,y,z }) => {
                        that.modelGroup.scale.set(x,y,z);
                      })
                      .start(); 

                      var coords = {x: that.modelGroup.rotation.z};
                      new Tween(coords)
                      .to({ x: Math.PI*2}, time || 2000)
                      .easing( Easing.Exponential.InOut )
                      .on('update', ({ x }) => {
                        that.modelGroup.rotation.z= x;
                      })
                      .start(); 
     } else {
                      var coords = {x: that.modelGroup.rotation.y};
                      new Tween(coords)
                      .to({ x: Math.PI*2}, time || 2000)
                      .easing( Easing.Exponential.InOut )
                      .on('update', ({ x }) => {
                        that.modelGroup.rotation.y = x;
                      })
                      .start(); 
     }



                      var coords = {y: that.modelGroup.position.y};
                      new Tween(coords)
                      .to({y: 15 }, time || 1000)
                      .easing( Easing.Exponential.In )
                      .on('update', ({y }) => {
                        that.modelGroup.position.y = y;  
                      })
                      .start(); 
                       
                      setTimeout( () => { 
                        var coords = {y: that.modelGroup.position.y};
                        new Tween(coords)
                        .to({y: 0 }, time || 1000)
                        .easing( Easing.Exponential.Out )
                        .on('update', ({y }) => {
                          that.modelGroup.position.y = y;  
                        })
                        .start();
                        let size = calcSize(that.modelGroup);
                        that.ground.position.y = ( (-size.y/2))-1;
                      }, time || 1000);
  }





  componentWillUnmount() {
    //this.removeFloorShape();
  //  console.log('componentWillUnmount');
    this.mouse.selected = null;
    this.mouse.hovered = null;
    this.removeItem(this.scene);
    this.stop();
    this.mount.removeChild(this.renderer.domElement);
  }

  moveControlsTarg(newPos) {
    //console.log();
    this.mouse.selectedContrls = true;
                var coords  = {
                  x: this.controls.target.x, y: this.controls.target.y, 
                  z: this.controls.target.z
                };
                new Tween(coords)
                .to({ x: newPos.x, y: newPos.y, z: newPos.z }, 300)
                .easing( Easing.Quadratic.Out )
                .on('update', ({ x, y, z }) => { 
                    this.controls.target.set(x, y, z);
                    this.camera.updateProjectionMatrix();
                })
                .start(); 
  }

  setFragElement(data) {
  
    //data.callback('something');
    this.dragElemUpdate = data.callback;
    this.element = +data.id;
    

    if (data.name) {

     this.elementName = data.name.toLowerCase().replace(new RegExp(" ",'g'),"_");

     this.meshToFly = this.groupDetails.find( mesh => (mesh.name === this.elementName && !mesh.userData.placed));
   
     if (this.meshToFly) this.meshToFly.material = this.materialFly;
    //this.meshToFly.scale.set(0.5, 0.5, 0.5);
    } else this.meshToFly = null;

  }


  handleIntersected() {
        this.raycaster.setFromCamera( this.mouse.vector, this.camera );
        let intersects = this.raycaster.intersectObjects( this.pointsForContruction );
        let intersectsFloor = this.raycaster.intersectObject( this.planeRay );
        let intersectDetails = this.raycaster.intersectObjects( this.groupDetails );

        if ( intersects.length ) {
          this.renderer.domElement.style.cursor = 'pointer';
          this.mouse.hovered = intersects[0].object;

          if (this.mouse.hovered.visible) this.mouse.hovered.material.color.setHex(0x0000ff);
          //else this.mouse.selected.material.color.setHex(0xff0000);  
        } else {
          this.renderer.domElement.style.cursor = 'auto';
          if (this.mouse.hovered) this.mouse.hovered.material.color.setHex(0xff0000);
          this.mouse.hovered = false;
        }



        if ( intersectsFloor.length ) {
          this.screenPoint = intersectsFloor[0].point;
        } else {
          this.screenPoint = null;
        }






        if (intersectDetails.length && intersectDetails[0].object.userData.placed && this.currentSphere) {

          this.renderer.domElement.style.cursor = 'pointer';
          //console.log('intersectDetails', intersectDetails[0].object.userData.id);//, intersectDetails[0].object
          if (this.detailInfoCurrent && this.detailInfoCurrent !== intersectDetails[0].object) {
            this.detailInfoCurrent.material = this.materialMetal;
            this.detailInfoCurrent = null;
          }

          
           if (this.mouse.selected) {
             //this.detailFocused = intersectDetails[0].object;
             //this.detailInfoCurrent.material = this.materialFocus;
             if (!this.movingProcced) {
              this.movingProcced = true;
              if (this.detailInfoCurrent) this.moveControlsTarg(this.detailInfoCurrent.position.clone().multiplyScalar(5));
              setTimeout( () => {
                this.movingProcced = false;
              }, 300);
             }

           }

           if (this.meshToFly && !this.meshToFly.visible && !this.detailInfoCurrent || !this.meshToFly && !this.detailInfoCurrent) {

            this.detailInfoCurrent = intersectDetails[0].object;
            this.detailInfoCurrent.material = this.materialFocus;

            for (let i = 0; i < this.elementsNames.length; i++) {
              if (this.elementsNames[i] === this.detailInfoCurrent.name ) {
                this.detailInfoCurrent.userData.imagesTitelsIndex = i;
                break;
              }
            }

            //if (!that.mouse.selected && that.detailInfoCurrent) {
              //that.mouse.selected = that.detailInfoCurrent;
              this.detailInfoSel = this.detailInfoCurrent.userData.imagesTitelsIndex;
              this.updateDetInfo();

             // console.log('1', this.element);
            //}


           }



        } else {
          if ( !intersects.length ) this.renderer.domElement.style.cursor = 'auto';
          
          //if (this.updateDetInfo) {}

          

          if (this.detailInfoCurrent) {
            this.detailInfoCurrent.material = this.materialMetal;

            this.detailInfoSel = +this.element - 1;
            this.updateDetInfo();

              //console.log(this.element);
        
            this.detailInfoCurrent = null;
          }
          //this.detailInfoCurrent = null;
          /*
          if (this.mouse.down && this.detailFocused) {
           if (this.detailFocused.material.name === 'materialFocus') {
            this.detailFocused.material = this.materialMetal;
           }
           this.detailFocused = null;
          }*/

        }
   
  }

  removeItem (item) {
      //let filtered = this.dragObjects.filter((elem) => elem !== item);
      //this.dragObjects = filtered;
      //filtered = this.collisionObjects.filter((elem) => elem !== item);
      //this.collisionObjects = filtered;
      let clearObjects = (holder) => {
        for (var j = holder.children.length - 1; j >= 0; j--) {
          let group = holder.children[j];
          let clearMesh = (group, mesh) => {
            mesh.visible = false;
            mesh.geometry.dispose();
            mesh.material.dispose();
            group.remove(mesh);
          }
          let clearGroup = (group) => {
            for (var i = group.children.length - 1; i >= 0; i--) {
              if (group.children[i].isMesh) {
                clearMesh(group, group.children[i]);
              } else if (group.children[i].isGroup) {
                clearGroup(group.children[i]);
              }
            }
          }
          clearGroup(group);
          group.children = [];
          holder.remove(group);
        }
      }
      clearObjects(item);
      //item.geometry.dispose();
      //item.visible = false;
      //this.scene.remove(item);
  }  




  start = () => {
      if (!this.frameId) {
        this.frameId = requestAnimationFrame(this.animate)
      }
  }
  stop = () => {
      cancelAnimationFrame(this.frameId)
  }

  animate = () => {
     this.renderscene()
     this.frameId = window.requestAnimationFrame(this.animate)
  }

  renderscene = () => {
    if (this.controls) this.controls.update();
    this.renderer.render(this.scene, this.camera);
    this.handleIntersected();

    if (this.currentSphere) {
      // this.currentSphere.scale = 
      // console.log( this.camera.position.distanceTo(this.currentSphere.position), this.camera.zoom )
      let dist = this.camera.position.distanceTo(this.currentSphere.position);
      if (dist > 10) {
        let scale = dist/(12 + (this.camera.zoom - 8));
        this.currentSphere.scale.set( scale, scale, scale );
      }
      
    }

    if (this.meshToFly && this.screenPoint && !this.meshToFly.userData.placed) {
      
      if (this.currentSphere) {
        let dist = this.camera.position.distanceTo( this.currentSphere.position );
        this.meshToFly.scale.set( 16 / dist, 16 / dist, 16 / dist  );
      }

      this.meshToFly.position.copy( this.screenPoint.clone().sub( this.camera.position.clone().multiplyScalar(0.8) ));

    } else if (this.meshToFly && this.meshToFly.userData.placed) {
      this.meshToFly.position.copy( this.meshToFly.userData.placedPos );
    }
  }

  render() {
    //console.log('render', this.state.toolsPositions, this.state.measurement);

    return (
      <div ref={(mount) => { this.mount = mount }} id="canvasView" style={{ height: 'inherit', width: 'inherit' }}>

      </div>
    )
  }
}

export default CanvasView;